import { logError } from "@lib/logger";
import { CookieKeys, getCookie } from "../../../lib/cookies";
import { createUser } from "../../visitWidgetApi";
import { AppDispatch } from "@store/store";
import { setAuthFlowAction, setAuthViewAction } from "@store/sessionReducer";
/*
 * Register user.
 */
export const registerUserAction =
  ({
    email,
    name,
    newsletters,
    captcha,
    postalCode,
  }: {
    email: string;
    name: string;
    newsletters: { id: number }[];
    captcha: string;
    postalCode?: string;
  }) =>
  async (dispatch: AppDispatch) => {
    try {
      const planId = await getCookie(CookieKeys.planId, undefined);

      await createUser({
        email,
        name,
        newsletters,
        captcha,
        postalCode,
        planId,
      });
      dispatch(setAuthFlowAction({ authFlow: "register" }));
      dispatch(setAuthViewAction({ authView: "magicLinkSent" }));
    } catch (error) {
      logError(error);
      throw error;
    }
  };
